<template>
  <div class="claims-process-tab">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-button type="success" @click="handleAdd">新增理赔流程</el-button>
    </div>
    
    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="processId" label="流程ID" width="150" />
      <el-table-column prop="title" label="标题" width="200" />
      <el-table-column prop="description" label="描述" show-overflow-tooltip />
      <el-table-column prop="icon" label="图标路径" width="200" show-overflow-tooltip />
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入描述"
          />
        </el-form-item>
        <el-form-item label="图标路径" prop="icon">
          <el-input v-model="form.icon" placeholder="请输入图标路径" />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getClaimsProcessList, addClaimsProcess, updateClaimsProcess, deleteClaimsProcess } from '@/api/guarantee'

export default {
  name: 'ClaimsProcessTab',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增理赔流程',
      form: {
        title: '',
        description: '',
        icon: '',
        sortOrder: 0
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请输入图标路径', trigger: 'blur' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      isEdit: false,
      editId: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      try {
        const response = await getClaimsProcessList()
        if (response.code === '200') {
          this.tableData = response.data
        } else {
          this.$message.error(response.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增理赔流程'
      this.form = {
        title: '',
        description: '',
        icon: '',
        sortOrder: 0
      }
      this.dialogVisible = true
    },
    
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑理赔流程'
      this.form = { ...row }
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该理赔流程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteClaimsProcess(row.id)
          if (response.code === '200') {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请重试')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.isEdit) {
              response = await updateClaimsProcess(this.form)
            } else {
              response = await addClaimsProcess(this.form)
            }
            
            if (response.code === '200') {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.msg || (this.isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请重试')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.claims-process-tab {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
}
</style> 